module.exports = __webpack_public_path__ + "media/images/top/ranking-sample09-0c6a9bacb375e58ed87471857d582076.jpg";